import { useEffect, useMemo, useState } from 'react';
import Lottie from 'lottie-react';
import classNames from 'classnames';
import generatingShippingLabel from '../../../../../animations/creating-label_v1.json';
import generatingShippingLabelTech from '../../../../../animations/generating-shipping-label.json';
import generatingShippingLabelVirtualBox from '../../../../../animations/creating-label-virtual-box.json';
import gettingEverythingReady from '../../../../../animations/getting-everything-ready.json';
import './GeneratingShippingLabel.scss';

export default function GeneratingShippingLabel({
  isTechRecycling = false,
  isVirtualBox = false,
  onShowingAnimation,
  animationsDuration = 2000,
}) {
  const [currentAnimation, setCurrentAnimation] = useState(0);

  const animations = useMemo(() => {
    const list = [];

    if (isTechRecycling) {
      list.push({ animation: generatingShippingLabelTech, duration: animationsDuration });
    } else if (isVirtualBox) {
      list.push({ animation: generatingShippingLabelVirtualBox, duration: animationsDuration });
    } else {
      list.push({ animation: generatingShippingLabel, duration: animationsDuration });
    }

    list.push({
      animation: gettingEverythingReady,
      duration: animationsDuration,
    });

    return list;
  }, [isTechRecycling, isVirtualBox]);

  useEffect(() => {
    let timeoutId;
    const currentDuration = animations[currentAnimation].duration;

    if (currentAnimation < animations.length - 1) {
      onShowingAnimation?.(true);

      timeoutId = setTimeout(() => {
        setCurrentAnimation(prev => prev + 1);
      }, currentDuration);
    } else {
      timeoutId = setTimeout(() => {
        onShowingAnimation?.(false);
      }, currentDuration);
    }

    return () => clearTimeout(timeoutId);
  }, [currentAnimation, animations]);

  return (
    <div
      className={classNames('GeneratingShippingLabel', {
        'GeneratingShippingLabel--tech': isTechRecycling,
      })}
    >
      <Lottie
        animationData={animations[currentAnimation].animation}
        loop
        autoplay
        style={{ aspectRatio: '1', height: '100%' }}
      />
    </div>
  );
}
